export const ARROW_SIZE = 'size-6';
export const ITEM_HEIGHT = 'h-94 am-3xl:h-104';
export const GAP_BETWEEN_ARROWS = 'gap-3 pr-5.5 am-3xl:gap-2 am-3xl:pr-0';
const mobileBleedRight = '-mr-4.5 am-3xl:mr-0 am-3xl:w-full';

export const viewportClasses = `overflow-hidden flex-1 ${ITEM_HEIGHT} ${mobileBleedRight}`;
export const slideContainerClasses = 'flex h-full gap-6';
export const slideItemClasses = 'flex-shrink-0 h-full';
const edgeGradientBackgroundClass =
  'bg-[linear-gradient(270deg,rgba(245,243,244,0)_0%,var(--carousel-edge-color,_#FFF)_33.33%)]';
export const rightEdgeGradientClasses = `pointer-events-none absolute inset-y-0 z-20 hidden w-12 -scale-x-100 am-md:block right-0 am-md:-right-8 ${edgeGradientBackgroundClass}`;
export const leftEdgeGradientClasses = `pointer-events-none absolute inset-y-0 z-20 hidden w-12 am-md:block left-0 am-md:-left-6 ${edgeGradientBackgroundClass}`;
export const arrowsRowClasses = `order-2 box-border flex justify-end am-xl:order-1 ${mobileBleedRight} ${GAP_BETWEEN_ARROWS}`;
